import React, { Suspense } from 'react';

import { LinearProgress } from '@/mui/components';

import styles from './DefaultSuspense.module.scss';

type Props = {
  children: React.ReactNode;
};

function DefaultSuspense({ children }: Props) {
  return <Suspense fallback={<LinearProgress color="inherit" className={styles.Suspense} />}>{children}</Suspense>;
}

export default DefaultSuspense;
